import { Car, Home, Building2, Heart } from "lucide-react";
import { InsuranceLink } from "./types";

export const insuranceLinks: InsuranceLink[] = [
  {
    title: "Auto Insurance",
    href: "/insurance/auto",
    description: "Comprehensive coverage for your vehicles",
    icon: Car,
  },
  {
    title: "Home Insurance",
    href: "/insurance/home",
    description: "Protect your most valuable asset",
    icon: Home,
  },
  {
    title: "Business Insurance",
    href: "/insurance/business",
    description: "Safeguard your company's future",
    icon: Building2,
  },
  {
    title: "Life Insurance",
    href: "/insurance/life",
    description: "Ensure your family's financial security",
    icon: Heart,
  },
];